"use client";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="max-w-[720px] mx-auto px-5 py-20 text-center">
      <h2 className="font-serif text-[22px] md:text-[28px] font-bold text-navy mb-2">
        Something went wrong
      </h2>
      <p className="text-[14px] text-text-muted mb-6">
        We hit a snag loading this page. Please try again.
      </p>
      <button
        onClick={() => reset()}
        className="px-5 py-2.5 bg-navy text-white text-[13px] font-semibold rounded-full hover:bg-navy/90 transition-colors"
      >
        Try again
      </button>
    </div>
  );
}
